<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header :pageId="this.$options.name"></sui-page-header>

    <!-- Page Contents -->
    <sui-page-contents>
      <button class="myBtn" @click="onBtnClick(1)">1 tab</button>
      <button class="myBtn" @click="onBtnClick(3)">3 tab</button>
      <button class="myBtn" @click="onBtnClick(5)">5 tab</button>
      <button class="myBtn" @click="onBtnClick(15)">15 tab</button>
      <!-- Search Box -->
      <div style="margin: 30px"></div>
      <sui-page-tab-box-type
        ref="tab"
        :tabItems="tabItems"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="setCurrentTabComponent"
        @change-tab-idx="tabSelected"
      >
        <container :is="currentTabComponent"/>
      </sui-page-tab-box-type>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import t02 from "./components/tab02.vue";
import t03 from "./components/tab03.vue";
import t04 from "./components/tab02.vue";
import t05 from "./components/tab03.vue";

// Page : import 이름이 pageID 와 동일 해야함
const PGE_CMU_00001 = utils.getPageComponentById("PGE_CMU_00001");
const PGE_CMU_00002 = utils.getPageComponentById("PGE_CMU_00002");

const tabs = [
  {
    tabTitle: "tab01",
    tabSubTitle: "sub01",
    component: "PGE_CMU_00001" // pageID
  },
  {
    tabTitle: "tab02",
    tabSubTitle: "sub02",
    component: "t02"
  },
  {
    tabTitle: "tab03",
    tabSubTitle: "sub03",
    component: "t03"
  },
  {
    tabTitle: "tab04",
    tabSubTitle: "sub02",
    component: "PGE_CMU_00002"
  },
  {
    tabTitle: "tab05",
    tabSubTitle: "sub03",
    component: "t05"
  },
  {
    tabTitle: "tab06",
    tabSubTitle: "sub03",
    component: "t05"
  },
  {
    tabTitle: "tab07",
    tabSubTitle: "sub03",
    component: "t05"
  },
  {
    tabTitle: "tab08",
    tabSubTitle: "sub03",
    component: "t05"
  },
  {
    tabTitle: "tab09",
    tabSubTitle: "sub03",
    component: "t05"
  },
  {
    tabTitle: "tab10",
    tabSubTitle: "sub03",
    component: "t05"
  },
  {
    tabTitle: "tab11",
    tabSubTitle: "sub03",
    component: "t05"
  },
  {
    tabTitle: "tab12",
    tabSubTitle: "sub03",
    component: "t05"
  },
  {
    tabTitle: "tab13",
    tabSubTitle: "sub03",
    component: "t05"
  },
  {
    tabTitle: "tab14",
    tabSubTitle: "sub03",
    component: "t05"
  },
  {
    tabTitle: "tab15",
    tabSubTitle: "sub03",
    component: "t05"
  },
];

export default {
  name: "PGE_CMZ_00001",
  components: {
    PGE_CMU_00001,
    PGE_CMU_00002,
    t02,
    t03,
    t05,
  },
  data() {
    return {
      // Tab
      defaultTabIndex: 0,
      tabItems: [
        {
          tabTitle: "tab01",
          tabSubTitle: "sub01",
          component: "PGE_CMU_00001" // pageID
        },
        {
          tabTitle: "tab02",
          tabSubTitle: "sub02",
          component: "t02"
        },
        {
          tabTitle: "tab03",
          tabSubTitle: "sub03",
          component: "t03"
        }
      ],
      currentTabComponent: null,
      tabIndex: 0
    };
  },
  methods: {
    setCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    changeTabIndex() {
      this.$refs.tab.changeIdx(++tabIndex % 3);
    },
    tabSelected(item) {
      console.log(item);
    },
    onBtnClick(cnt) {
      const newTabs = [];
      for (let i = 0; i < cnt; i++) {
        newTabs.push(tabs[i]);
      }
      this.tabItems = newTabs;
      // this.tabItems: [
      //   {
      //     tabTitle: "tab01",
      //     tabSubTitle: "sub01",
      //     component: "PGE_CMU_00001" // pageID
      //   },
      //   {
      //     tabTitle: "tab02",
      //     tabSubTitle: "sub02",
      //     component: "t02"
      //   },
      //   {
      //     tabTitle: "tab03",
      //     tabSubTitle: "sub03",
      //     component: "t03"
      //   }
      // ],
    }
  },
};
</script>
<style scoped>
.myBtn {
  width: 100px;
  height: 30px;
  border: 1px solid red;
}
</style>
